export const MINIMUM_PLATFORM_FEE_CAD = 5
export const DEFAULT_PLATFORM_FEE_PERCENTAGE = 0.6

// Default fallback limits (used only when dynamic limits are unavailable)
export const DEFAULT_MIN_SEND_AMOUNT = 10
export const DEFAULT_MAX_SEND_AMOUNT = 10000

/**
 * Converts USDC amount to CAD using exchange rate
 */
export const convertUsdcToCad = (
  usdcAmount: number,
  cadUsdcRate?: number,
  fallbackRate: number = 1.38
): number => {
  const exchangeRate = cadUsdcRate || fallbackRate
  return usdcAmount / exchangeRate
}

/**
 * Calculates platform fee in CAD (minimum 5 CAD or percentage of send amount)
 */
export const calculatePlatformFeeInCad = (
  sendAmountUsdc: number,
  cadUsdcRate?: number,
  platformFeePercentage: number = DEFAULT_PLATFORM_FEE_PERCENTAGE
): number => {
  const platformFeeUsdc = (sendAmountUsdc * platformFeePercentage) / 100
  const platformFeeInCad = convertUsdcToCad(platformFeeUsdc, cadUsdcRate)

  return Math.max(platformFeeInCad, MINIMUM_PLATFORM_FEE_CAD)
}

/**
 * Calculates total fee in CAD (provider fee + platform fee)
 */
export const calculateTotalFeeInCad = (
  providerFeeUsdc: number,
  sendAmountUsdc: number,
  cadUsdcRate?: number,
  platformFeePercentage: number = DEFAULT_PLATFORM_FEE_PERCENTAGE
): number => {
  const providerFeeInCad = convertUsdcToCad(providerFeeUsdc, cadUsdcRate)
  const platformFeeInCad = calculatePlatformFeeInCad(
    sendAmountUsdc,
    cadUsdcRate,
    platformFeePercentage
  )

  return providerFeeInCad + platformFeeInCad
}
